<template lang="html">
<div>
  <v-navigation-drawer fixed v-model="drawer" app v-if="AuthUser.id">
    <div :style='{"background-color": subDomain.header_color,
                 "background-border-color": subDomain.header_color,
                 "height": "100px"
                 }' class="sub-menu-header align-center flex-center" >
      <img class="img-logo" :style="{'max-height': (subDomain.logo_height || '50') + 'px' }" :src="subDomain.logo || '/img/white_logo.png'" alt="logo">
    </div>
    <h-side-bar
      v-if="AuthUser.profile"
      :user="AuthUser"
      :subDomain="subDomain"
      :notificationColor="notificationColor"
      @logout="logout"
      @tutorial="url => displayTutorial = url" />

  </v-navigation-drawer>
  <div :style='{"background-color": subDomain.header_color,
                       "background-border-color": subDomain.header_color}'
                       dark app
                       style="width: 100%; display: flex; justify-content: space-between; height: 100px"
                       class="main-tool-bar"
                       :class="{'white-nav': isHeaderLight()}">
    <div style="display: flex; align-items: center;">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="AuthUser.id"></v-toolbar-side-icon>
      <div v-if="!drawer" class="align-center flex-center">
        <img v-if="subDomain.logo" class="img-logo" :style="{'max-height': (subDomain.logo_height || '50') + 'px', 'padding-left': !AuthUser.id && '50px' }" :src="subDomain.logo" alt="logo" />
      </div>
    </div>
    <div style="display: flex; align-items: center; margin-right: 20px" v-if="AuthUser.id">
      <!-- <div class="raffle-info" v-if="user.raffle_opt_in && !$route.path.match(/new-user/g)"> <div
          class='raffle-tickets'
          :class="{updateTicket}"
          >{{user.weekly_num_of_tickets}}</div>
        <div>Weekly Tickets</div>
      </div> -->
      <router-link to="/settings">
        <avatar :image="AuthUser.image" />
      </router-link>
    </div>
    <router-link 
      :style="{color: isHeaderLight() ? 'black' : 'white'}"
      style="font-size: 18px; display: flex; align-items: center; margin-right: 20px; text-decoration: none" to="/sign-in" v-if="!AuthUser.id">Login</router-link>
  </div>

  <v-content class="main-content">
    <div class="card card--container main-content-container">
      <reward-modal @updateTickets="updateTickets" />
      <div v-if="displayTutorial" class="tutorial">
        <h-icon @click="displayTutorial=false">close</h-icon>
        <iframe width="560" height="315" :src="'https://www.youtube.com/embed/' + displayTutorial" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <router-view style="margin-bottom: 30px"></router-view>
      <v-snackbar class="clickable" :timeout="2000" :bottom="true" :left="true" v-model="snackbar" @click="snackbar = false">
        {{ text }} 
      </v-snackbar>
      <v-snackbar class="clickable" :bottom="true" :left="true" :timeout="0" v-model="newVersion" @click="updateApp">
        A new version of the app is available. 
      </v-snackbar>
      <v-snackbar class="clickable" @click=" notifySurvey = false || $router.push('/daily-reflection')" :bottom="true" :right="true" :timeout="10000" v-model="notifySurvey">
        Don't forget to do your daily reflection
      </v-snackbar>
    </div>
  </v-content>
  <!-- <add-two-home-screen /> -->
  <impersonating v-if="AuthUser.impersonating" />
  <tutorial />
  <client-messages :user="AuthUser" v-if="!AuthUser.has_coach_license"/>
</div>
</template>
<script>
import User from "@/services/api/authUser";
import rewardModal from "@/components/rewardModal";
import snackbarHub from "@/services/hubs/snackbar";
import userHub from "@/services/hubs/user";
import subdomainHub from "@/services/hubs/subDomain";
import subDomain from "@/services/api/subDomains";
import impersonating from "@/components/impersonatingWarning";
import tinycolor from "tinycolor2";
import versionHub from "@/services/hubs/version";
import { registerServiceWorker } from "@/registerServiceWorker";
import avatar from "@/components/userImg";
import messageCounter from "@/components/messages/counter";
import pushNotifications from "@/services/pushNotifications/";
import Nazgul from "@/services/nazgul";
import store from "@/services/api/store";
import tutorial from "@/components/tutorial";
import sideBar from "./sideBar";
import addTwoHomeScreen from "@/components/add2HomeScreen";
import clientMessages from "./clientMessages";
import modal from "@/components/modal";


export default {
  name: "App",
  data: () => ({
    drawer: null,
    snackbar: false,
    text: "",
    isLoggedIn: User.isLoggedIn(),
    updateTicket: false,
    subDomainLoaded: false,
    subDomain: {},
    user: {},
    AuthUser: User,
    newVersion: false,
    notifySurvey: false,
    shouldShowClientTour: false,
    displayTutorial: ""
  }),
  props: {
    source: String
  },
  created() {
    this.$eventHub.$on("youtubeTutorial", id => {
      this.displayTutorial = id;
    });

    snackbarHub.registerListener(text => {
      this.text = text;
      this.snackbar = true;
    });

    userHub.registerListener(user => {
      this.user = user;
      if (user.id) {
        store
          .findAll("ClientSurveys", { limit: 1 }, { force: true })
          .then(surveys => {
            const survey = surveys[0];
            if (
              !User.impersonating &&
              survey &&
              !survey.completed_at &&
              this.$route.name !== "dailyReflection"
            ) {
              this.notifySurvey = true;
            }
          });

        pushNotifications
          .requestPermission()
          .then(() => pushNotifications.retrieveToken());
      }
    });
    subdomainHub.$on('update', subdomain => {
      this.subDomain = { ...this.subDomain, ...subdomain };
    });
    subDomain().then(sub => {
      this.subDomain = sub;
      this.subDomainLoaded = true;
    });
    registerServiceWorker.start();
    versionHub.registerListener(version => {
      if (process.env.NODE_ENV === "production") {
        this.newVersion = version !== process.env.VUE_APP_VERSION;
      }
    });
  },
  methods: {
    changeNotification() {
      this.notifySurvey = false;
    },
    logout() {
      Nazgul.report("logout");
      User.logout();
      this.$router.push("/");
      this.isLoggedIn = User.isLoggedIn();
    },
    updateLoggedIn() {
      this.isLoggedIn = User.isLoggedIn();
    },
    displaySnackbar(text) {
      this.text = text;
      this.snackbar = true;
    },
    updateApp() {
      location.reload(true);
    },
    updateTickets(tickets) {
      this.updateTicket = true;
      let numOfTickets = this.user.weekly_num_of_tickets + tickets;
      let intervalInc = Number.parseInt(tickets / 15) || 1;
      let interval = setInterval(() => {
        if (this.user.weekly_num_of_tickets + intervalInc >= numOfTickets) {
          this.user.weekly_num_of_tickets = numOfTickets;
          clearInterval(interval);
          this.updateTicket = false;
        } else {
          this.user.weekly_num_of_tickets += intervalInc;
        }
      }, 200);
    },
    isHeaderLight() {
      let hex = this.subDomain.header_color;
      return tinycolor(hex).isLight();
    }
  },
  computed: {
    notificationColor() {
      return this.notifySurvey ? "orange" : "";
    }
  },
  components: {
    rewardModal,
    impersonating,
    addTwoHomeScreen,
    avatar,
    messageCounter,
    tutorial,
    hSideBar: sideBar,
    clientMessages,
    modal
  }
};
</script>

<style lang="less">
.tutorial {
  position: fixed;
  left: calc(50vw - 560px / 2);
  margin: 0px auto;
  border-radius: 0px;
  z-index: 100;
  i {
    position: absolute;
    top: -10px;
    right: -5px;
    background-color: white;
    border-radius: 50%;
    cursor: pointer;
  }
  iframe {
    max-width: 100%;
  }
}
</style>
